// Shim for Node.js querystring module
// Uses the browser's native URLSearchParams API

export function parse(str, sep = '&', eq = '=') {
    if (!str || typeof str !== 'string') {
        return {};
    }
    
    const result = {};
    const params = new URLSearchParams(str);
    
    for (const [key, value] of params) {
        if (Object.prototype.hasOwnProperty.call(result, key)) {
            // Handle multiple values for same key
            if (Array.isArray(result[key])) {
                result[key].push(value);
            } else {
                result[key] = [result[key], value];
            }
        } else {
            result[key] = value;
        }
    }
    
    return result;
}

export function stringify(obj, sep = '&', eq = '=') {
    if (!obj || typeof obj !== 'object') {
        return '';
    }
    
    const params = new URLSearchParams();
    
    for (const [key, value] of Object.entries(obj)) {
        if (Array.isArray(value)) {
            value.forEach(v => params.append(key, v));
        } else if (value !== undefined && value !== null) {
            params.append(key, value);
        }
    }
    
    return params.toString();
}

export function encode(str) {
    return encodeURIComponent(str);
}

export function decode(str) {
    return decodeURIComponent(str);
}

export default { parse, stringify, encode, decode };
